// src/mocks/handlers/funding/invoicesIssuedDetailsHandler.ts

import { rest } from 'msw';
import invoicesIssuedDetails from '@/mocks/data/fundingIssuedInvoicesDetailsData.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { IInvoicesIssuedDetailsResponse } from '@/domains/funding/invoices.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingInvoicesIssuedDetailsHandler =
  rest.get<IInvoicesIssuedDetailsResponse>(
    `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_INVOICES_ISSUED}`,
    (req, res, ctx) => {
      const token = req.headers.get('Authorization');
      if (!token) {
        return res(
          ctx.status(500),
          ctx.json({ detail: 'Something went wrong' }),
        );
      }

      if (isAccessTokenExpired()) {
        return res(
          ctx.status(401),
          ctx.json({ error: 'Access token expired' }),
        );
      }

      const { customer_uuid, invoice_uuid } = req.params as {
        customer_uuid: string;
        invoice_uuid: string;
      };

      // Mock response data
      const customerData = (invoicesIssuedDetails as any[]).find(
        (entry) => entry.uuid === customer_uuid,
      );

      if (!customerData) {
        return res(ctx.status(404), ctx.json({ detail: 'Customer not found' }));
      }

      const invoiceData = customerData.results.find(
        (invoice: any) => invoice.uuid === invoice_uuid,
      );

      if (!invoiceData) {
        return res(
          ctx.status(404),
          ctx.json({ detail: 'Invoice not found for this customer' }),
        );
      }

      // Return the mock response
      return res(
        ctx.status(200),
        ctx.json({ issued_invoices: invoiceData.issued_invoices }),
      );
    },
  );
